import * as core from '../../../../../../../core'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'outcome-explore',
    appAlias: summit.RESOURCE.payload.alias,
    description: 'TODO',
    name: 'Outcome (Explore)',
    page: { alias: 'summit:outcome-explore' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
